export const KeepMark = ({ size = 32, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path d="M7 3h4v3.5h3.5V3h3v3.5H21V3h4" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    <path
      d="M5.5 8.5h21V18c0 5.5-4.6 9-10.5 10.8C10.1 27 5.5 23.5 5.5 18V8.5Z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    <path
      d="M12.2 12.5v10M12.2 18.2 19.5 12.5M13.6 16.4l6.1 6.1"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const VaultRing = ({ className = "" }) => (
  <svg viewBox="0 0 600 600" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
    <circle cx="300" cy="300" r="290" stroke="currentColor" strokeWidth="0.75" />
    <circle cx="300" cy="300" r="240" stroke="currentColor" strokeWidth="0.5" strokeDasharray="3 6" />
    <circle cx="300" cy="300" r="180" stroke="currentColor" strokeWidth="0.75" />
    <circle cx="300" cy="300" r="60" stroke="currentColor" strokeWidth="0.75" />
    {Array.from({ length: 24 }).map((_, i) => {
      const a = (i * 15 * Math.PI) / 180;
      const x1 = 300 + 255 * Math.cos(a);
      const y1 = 300 + 255 * Math.sin(a);
      const x2 = 300 + 285 * Math.cos(a);
      const y2 = 300 + 285 * Math.sin(a);
      return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="currentColor" strokeWidth="0.75" />;
    })}
    {Array.from({ length: 8 }).map((_, i) => {
      const a = (i * 45 * Math.PI) / 180;
      const x1 = 300 + 70 * Math.cos(a);
      const y1 = 300 + 70 * Math.sin(a);
      const x2 = 300 + 175 * Math.cos(a);
      const y2 = 300 + 175 * Math.sin(a);
      return <line key={`s${i}`} x1={x1} y1={y1} x2={x2} y2={y2} stroke="currentColor" strokeWidth="0.5" />;
    })}
  </svg>
);
